export type SubscriptionState = {
  steps: StepState[];
};

export type StepState = {
  url: string;
  isActive: boolean;
  isCompleted: boolean;
  isAutomatic: boolean;
};

export const initialSubscriptionState: SubscriptionState = {
  steps: []
};
